import { BaseAccordion } from "@/components/atom/accordion/BaseAccordion";
import { AccordionProps } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";

interface ExpandablePanelProps extends AccordionProps {}

const ExpandableInspectAccordion = (props: ExpandablePanelProps) => {
  const { children, ...etcProps } = props;
  return (
    <BaseAccordion
      w={"100%"}
      chevron={<IconPlus size="2.5rem" color="black" />}
      styles={{
        item: { border: `1px solid gray` },
        chevron: {
          color: "white",
          "&[data-rotate]": {
            transform: "rotate(45deg)",
          },
        },
      }}
      {...etcProps}
    >
      {children}
    </BaseAccordion>
  );
};

export default ExpandableInspectAccordion;
